module.exports = __webpack_public_path__ + "static/media/swap_send_buy_sell.f16adeb0.png";